module.exports = {
  levelOne: 1,
  levelTwo: 999,
  levelThree: 1000,
  levelFour: 111111,
  levelFive: 1000000,
};
